const Common = {
  '请稍等': '请稍等',
  '操作成功': '操作成功',
  '正常': '正常',
  '系统加载中': '系统加载中',
  '新增': '新增',
  '编辑': '编辑',
  '已选中#条记录': '已选中#条记录',
  '未选中任何数据': '未选中任何数据',
  '清空': '清空',
  '删除': '删除',
  '批量删除': '批量删除',
  '详情': '详情',
  '活跃': '活跃',
  '冻结': '冻结',
  '启用': '启用',
  '搜索': '搜索',
  '重置': '重置',
  '操作': '操作',
  '取消': '取消',
  '确定': '确定',
  '状态': '状态',
  '创建时间': '创建时间',
  '全选': '全选',
  '确定冻结': '确定冻结',
  '确定启用': '确定启用',
  '确定删除': '确定删除',
  '确定取消': '确定取消',
  '确定完成': '确定完成',
  '确定下单': '确定下单',
  '确定作废': '确定作废',
  '确定重置': '确定重置',
  '冻结成功': '冻结成功',
  '启用成功': '启用成功',
  '删除成功': '删除成功',
  '重置成功': '重置成功',
  '重置密码': '重置密码',
  '全部': '全部',
  '备注': '备注',
  '请输入备注': '请输入备注',
  '暂无数据': '暂无数据',
  '装箱码': '装箱码',
  '请输入装箱码': '请输入装箱码',
  '激活码': '激活码',
  '请输入激活码': '请输入激活码',
  '产品码': '产品码',
  '请输入产品码': '请输入产品码',
  '第三方激活码': '第三方激活码',
  '待完成': '待完成',
  '已收单': '已收单',
  '已完成': '已完成',
  '已作废': '已作废',
  '待下单': '待下单',
  '产品名称': '产品名称',
  '产品图片': '产品图片',
  '基本信息': '基本信息',
  '序号': '序号',
  '编码': '编码',
  '请输入编码': '请输入编码',
  '暂无': '暂无',
  '待生产': '待生产',
  '已装盒': '已装盒',
  '已装箱': '已装箱',
  '生产入库': '生产入库',
  '采购入库': '采购入库',
  '销售出库': '销售出库',
  '出库激活': '出库激活',
  '电商激活': '电商激活',
  '完成售后': '完成售后',
  '售后激活': '售后激活',
  '补货出库': '补货出库',
  '补货入库': '补货入库',
  '订单号': '订单号',
  '箱规': '箱规',
  '请输入箱规': '请输入箱规',
  '箱规必须大于0': '箱规必须大于0',
  '请选择产品': '请选择产品',
  '上一步': '上一步',
  '下一步': '下一步',
  '名称': '名称',
  '图片': '图片',
  '单价': '单价',
  '通知': '通知',
  '开始日期': '开始日期',
  '结束日期': '结束日期',
  '请输入': '请输入',
  '打印': '打印',
  '初始化打印程序失败，请联系技术人员处理': '初始化打印程序失败，请联系技术人员处理',
  '请选择打印机': '请选择打印机',
  '当前打印数据': '当前打印数据',
  '打印进度': '打印进度',
  '停止打印': '停止打印',
}

const Layout = {
  '语言': '语言',
  '简体中文': '简体中文',
  '繁体中文': '繁体中文',
  '英文': '英文',
  '修改密码': '修改密码',
  '退出登录': '退出登录',
  '溯源管理系统': '溯源管理系统',
}

const Menu = {
  '租户管理': '租户管理',
  '租户列表': '租户列表',
  '新增租户': '新增租户',
  '编辑租户': '编辑租户',
  '删除租户': '删除租户',
  '系统管理': '系统管理',
  '角色管理': '角色管理',
  '角色列表': '角色列表',
  '新增角色': '新增角色',
  '编辑角色': '编辑角色',
  '删除角色': '删除角色',
  '员工管理': '员工管理',
  '员工列表': '员工列表',
  '新增员工': '新增员工',
  '编辑员工': '编辑员工',
  '删除员工': '删除员工',
  '销售管理': '销售管理',
  '销售单': '销售单',
  '销售单列表': '销售单列表',
  '新增销售单': '新增销售单',
  '编辑销售单': '编辑销售单',
  '销售出库': '销售出库',
  '销售出库列表': '销售出库列表',
  '新增销售出库': '新增销售出库',
  '采购管理': '采购管理',
  '采购单': '采购单',
  '采购单列表': '采购单列表',
  '新增采购单': '新增采购单',
  '编辑采购单': '编辑采购单',
  '采购入库': '采购入库',
  '采购入库列表': '采购入库列表',
  '新增采购入库': '新增采购入库',
  '产品管理': '产品管理',
  '产品库': '产品库',
  '产品列表': '产品列表',
  '新增产品': '新增产品',
  '编辑产品': '编辑产品',
  '删除产品': '删除产品',
  '在售产品': '在售产品',
  '在售产品列表': '在售产品列表',
  '新增在售产品': '新增在售产品',
  '删除在售产品': '删除在售产品',
  '供应商管理': '供应商管理',
  '供应商列表': '供应商列表',
  '新增供应商': '新增供应商',
  '编辑供应商': '编辑供应商',
  '删除供应商': '删除供应商',
  '代理管理': '代理管理',
  '代理列表': '代理列表',
  '只展示拥有的代理': '只展示拥有的代理',
  '新增代理': '新增代理',
  '编辑代理': '编辑代理',
  '删除代理': '删除代理',
  '生产管理': '生产管理',
  '生产单': '生产单',
  '生产单列表': '生产单列表',
  '新增生产单': '新增生产单',
  '编辑生产单': '编辑生产单',
  '生产入库': '生产入库',
  '生产入库列表': '生产入库列表',
  '新增生产入库': '新增生产入库',
  '库存管理': '库存管理',
  '库存明细': '库存明细',
  '库存明细列表': '库存明细列表',
  '库存变动': '库存变动',
  '库存变动列表': '库存变动列表',
  '工厂测试': '工厂测试',
  '扫码装盒': '扫码装盒',
  '扫码装箱': '扫码装箱',
  '扫码校验': '扫码校验',
  '扫码激活': '扫码激活',
  '电商激活': '电商激活',
  '打印记录': '打印记录',
  '打印记录列表': '打印记录列表',
  '新增打印记录': '新增打印记录',
  '编辑打印记录': '编辑打印记录',
  '溯源管理': '溯源管理',
  '售后管理': '售后管理',
  '售后列表': '售后列表',
  '新增售后': '新增售后',
  '退货管理': '退货管理',
  '退货列表': '退货列表',
  '新增退货': '新增退货',
  '编辑退货': '编辑退货',
  'App用户管理': 'App用户管理',
  'App用户列表': 'App用户列表',
  '编辑App用户': '编辑App用户',
  '删除App用户': '删除App用户',
  '数据统计': '数据统计',
  '激活记录': '激活记录',
  '编辑在售产品': '编辑在售产品',
  '第三方激活码管理': '第三方激活码管理',
  '第三方激活码订单': '第三方激活码订单',
  '第三方激活记录': '第三方激活记录',
  '第三方激活码订单列表': '第三方激活码订单列表',
  '新增第三方激活码订单': '新增第三方激活码订单',
  '编辑第三方激活码订单': '编辑第三方激活码订单',
  '通知管理': '通知管理',
  '代购管理': '代购管理',
  '代购列表': '代购列表',
  '新增代购': '新增代购',
  '只展示自己的代购': '只展示自己的代购',
  '活动管理': '活动管理',
  '活动列表': '活动列表',
  '新增活动': '新增活动',
  '编辑活动': '编辑活动',
  '删除活动': '删除活动',
  '扫码验奖': '扫码验奖',
}

const Region = {
  '马来西亚': '马来西亚',
  '玻璃市': '玻璃市',
  '吉打': '吉打',
  '槟城': '槟城',
  '霹雳': '霹雳',
  '雪兰莪': '雪兰莪',
  '森美兰': '森美兰',
  '马六甲': '马六甲',
  '柔佛': '柔佛',
  '彭亨': '彭亨',
  '登嘉楼': '登嘉楼',
  '吉兰丹': '吉兰丹',
  '砂拉越': '砂拉越',
  '沙巴': '沙巴',
  '吉隆坡': '吉隆坡',
  '纳闽': '纳闽',
  '布城': '布城',
  '印度尼西亚': '印度尼西亚',
  '菲律宾': '菲律宾',
  '新加坡': '新加坡',
  '泰国': '泰国',
  '越南': '越南',
  '缅甸': '缅甸',
  '东帝汶': '东帝汶',
  '文莱': '文莱',
  '柬埔寨': '柬埔寨',
  '老挝': '老挝',
  '阿根廷': '阿根廷',
  '巴拉圭': '巴拉圭',
  '巴西': '巴西',
  '秘鲁': '秘鲁',
  '玻利维亚': '玻利维亚',
  '厄瓜多尔': '厄瓜多尔',
  '法属圭亚那': '法属圭亚那',
  '哥伦比亚': '哥伦比亚',
  '圭亚那': '圭亚那',
  '苏里南': '苏里南',
  '委内瑞拉': '委内瑞拉',
  '乌拉圭': '乌拉圭',
  '智利': '智利',
  '福克兰群岛': '福克兰群岛',
}

const ModifyPasswordPage = {
  '修改密码': '修改密码',
  '旧密码': '旧密码',
  '请输入旧密码': '请输入旧密码',
  '新密码': '新密码',
  '请输入新密码': '请输入新密码',
  '密码长度必须介于 6 和 20 之间': '密码长度必须介于 6 和 20 之间',
  '确认密码': '确认密码',
  '请再次输入密码': '请再次输入密码',
  '两次输入的密码不一致': '两次输入的密码不一致',
  '修改成功': '修改成功',
}

const LoginPage = {
  '账号': '账号',
  '请输入账号': '请输入账号',
  '密码': '密码',
  '请输入密码': '请输入密码',
  '验证码': '验证码',
  '请输入验证码': '请输入验证码',
  '登录': '登录',
}

const TenantPage = {
  '公司名称': '公司名称',
  '公司联系方式': '公司联系方式',
  '公司邮箱': '公司邮箱',
  '管理员名称': '管理员名称',
  '管理员联系方式': '管理员联系方式',
  '管理员邮箱': '管理员邮箱',
  '菜单权限': '菜单权限',
  '管理员账号': '管理员账号',
  '请输入公司名称': '请输入公司名称',
  '请输入公司联系方式': '请输入公司联系方式',
  '请输入公司邮箱': '请输入公司邮箱',
  '请输入管理员名称': '请输入管理员名称',
  '请输入管理员联系方式': '请输入管理员联系方式',
  '请输入管理员邮箱': '请输入管理员邮箱',
  '邮箱格式错误': '邮箱格式错误',
  '请选择菜单权限': '请选择菜单权限',
  '新增租户': '新增租户',
  '编辑租户': '编辑租户',
  '查看租户': '查看租户',
}

const RolePage = {
  '角色名称': '角色名称',
  '请输入角色名称': '请输入角色名称',
  '新增角色': '新增角色',
  '编辑角色': '编辑角色',
  '查看角色': '查看角色',
  '确定编辑？与该角色关联的账号的权限将会被覆盖': '确定编辑？与该角色关联的账号的权限将会被覆盖',
}

const StaffPage = {
  '员工账号': '员工账号',
  '员工名称': '员工名称',
  '角色': '角色',
  '请输入员工账号': '请输入员工账号',
  '员工账号只能包含数字、英文大小写': '员工账号只能包含数字、英文大小写',
  '员工账号长度必须介于 6 和 20 之间': '员工账号长度必须介于 6 和 20 之间',
  '账号只能包含数字、英文大小写': '账号只能包含数字、英文大小写',
  '请输入员工名称': '请输入员工名称',
  '请选择角色': '请选择角色',
}

const PrintRecordPage = {
  '开始': '开始',
  '确定开始': '确定开始',
  '暂停': '暂停',
  '确定暂停': '确定暂停',
  '打印类型': '打印类型',
  '总数量': '总数量',
  '打印数量': '打印数量',
  '排队中': '排队中',
  '打印中': '打印中',
  '已暂停': '已暂停',
  '已完成': '已完成',
  '已取消': '已取消',
  '打印机状态': '打印机状态',
}

const ThirdPartyActivationCodeOrderPage = {
  '订单编号': '订单编号',
  '作废后该订单的所有编码不可使用': '作废后该订单的所有编码不可使用',
  '数量': '数量',
  '请输入数量': '请输入数量',
  '数量必须大于0': '数量必须大于0',
  '新增订单': '新增订单',
  '未打印': '未打印',
  '已打印': '已打印',
  '异常打印': '异常打印',
  '打印': '打印',
  '全部打印': '全部打印',
  '请先选择要打印的激活码': '请先选择要打印的激活码',
  '打印任务已创建，请到打印记录中查看': '打印任务已创建，请到打印记录中查看',
}

const ThirdPartyActivationCodeRecordPage = {
  '商品名称': '商品名称',
  '保修天数': '保修天数',
  '代理': '代理',
  '激活时间': '激活时间',
  '剩余保修天数': '剩余保修天数',
  '激活人': '激活人',
}

const TraceCodePage = {
  '溯源': '溯源',
  '暂无溯源信息': '暂无溯源信息',
  '产品信息': '产品信息',
  '产品单价': '产品单价',
  '包装信息': '包装信息',
  '装箱信息': '装箱信息',
  '装箱情况': '装箱情况',
  '当前节点': '当前节点',
  '产品节点': '产品节点',
  '激活状态': '激活状态',
  '剩余时间（天）': '剩余时间（天）',
  '销售门店': '销售门店',
  '绑定用户': '绑定用户',
  '激活账号': '激活账号',
  '已激活': '已激活',
  '未激活': '未激活',
}

const ReturnPage = {
  '我的退货': '我的退货',
  '处理退货': '处理退货',
  '确定收货': '确定收货',
  '完成退货': '完成退货',
  '退货详情': '退货详情',
  '补发详情': '补发详情',
  '退货数量': '退货数量',
  '退货收货数量': '退货收货数量',
  '补发数量': '补发数量',
  '补发收货数量': '补发收货数量',
  '退货人': '退货人',
  '补发人': '补发人',
  '退货中': '退货中',
  '收货中': '收货中',
  '已收货': '已收货',
  '补发中': '补发中',
  '已补发': '已补发',
  '已完成': '已完成',
  '售后类型': '售后类型',
  '其他': '其他',
  '其他原因': '其他原因',
}

const StockChangePage = {
  '类型': '类型',
  '关联订单号': '关联订单号',
  '商品数量': '商品数量',
  '关联生产单信息': '关联生产单信息',
  '关联销售单信息': '关联销售单信息',
  '销售数量': '销售数量',
  '关联采购单': '关联采购单',
  '客户': '客户',
  '客户拥有人': '客户拥有人',
  '关联采购单信息': '关联采购单信息',
  '采购数量': '采购数量',
  '供应商': '供应商',
}

const StockPage = {
  '库存详情': '库存详情',
}

const SaleOutWarehousePage = {
  '请选择关联销售单': '请选择关联销售单',
}

const SaleOrderPage = {
  '确定接收': '确定接收',
  '创建生产单': '创建生产单',
  '销售出库详情': '销售出库详情',
  '采购地区': '采购地区',
  '销售出库数量': '销售出库数量',
  '发货时间': '发货时间',
  '请输入采购数量': '请输入采购数量',
  '采购数量必须大于0': '采购数量必须大于0',
  '请选择客户': '请选择客户',
  '请选择采购地区': '请选择采购地区',
  '请选择出货日期': '请选择出货日期',
  '采购方': '采购方',
  '采购方备注': '采购方备注',
}

const PurchaseInWarehousePage = {
  '采购商品数量': '采购商品数量',
  '入库商品数量': '入库商品数量',
}

const PurchaseOrderPage = {
  '采购': '采购',
  '发货日期': '发货日期',
  '采购入库详情': '采购入库详情',
  '采购入库数量': '采购入库数量',
  '请选择供应商': '请选择供应商',
  '请输入采购数量': '请输入采购数量',
  '采购数量必须大于0': '采购数量必须大于0',
  '请选择发货日期': '请选择发货日期',
  '发货数量': '发货数量',
  '出货备注': '出货备注',
  '入库备注': '入库备注',
  '销售方': '销售方',
  '销售方备注': '销售方备注',
}

const AppUserPage = {
  '用户名称': '用户名称',
  '手机号': '手机号',
  '邮箱': '邮箱',
  '用户账号': '用户账号',
  '车型': '车型',
  '绑定数': '绑定数',
}

const ProduceInWarehousePage = {
  '请选择关联生产单': '请选择关联生产单',
}

const ProduceOrderPage = {
  '生产入库详情': '生产入库详情',
  '生产数量': '生产数量',
  '生产入库数量': '生产入库数量',
  '请输入生产数量': '请输入生产数量',
  '生产数量必须大于0': '生产数量必须大于0',
  '请输入装箱码、激活码或者产品码': '请输入装箱码、激活码或者产品码',
  '产品箱装数量': '产品箱装数量',
  '请先选择要打印的装箱码': '请先选择要打印的装箱码',
  '确定要打印#个装箱码': '确定要打印#个装箱码',
  '请先选择要打印的产品码': '请先选择要打印的产品码',
  '确定要打印#个产品码': '确定要打印#个产品码',
  '绑定状态': '绑定状态',
  '已绑定': '已绑定',
  '待绑定': '待绑定',
  '新增箱子': '新增箱子',
  '编辑箱子': '编辑箱子',
  '箱子数量': '箱子数量',
  '请输入箱子数量': '请输入箱子数量',
  '箱子数量必须大于0': '箱子数量必须大于0',
  '编码生成方式': '编码生成方式',
  '设备生成': '设备生成',
  '系统生成': '系统生成',
}

const OnSaleProductPage = {
  '库存': '库存',
  '请输入库存': '请输入库存',
  '新增在售产品': '新增在售产品',
  '配置在售产品': '配置在售产品',
  '旧单价': '旧单价',
  '单价更新时间': '单价更新时间',
}

const ProductPage = {
  '导入': '导入',
  '模版下载': '模版下载',
  '文件格式为.xlsx、.xls': '文件格式为.xlsx、.xls',
  '导入完毕，成功：#1，失败：#2': '导入完毕，成功：#1，失败：#2',
  '产品导入模板': '产品导入模板',
  '请输入产品名称': '请输入产品名称',
  '请上传图片': '请上传图片',
  '请输入产品单价': '请输入产品单价',
  '请输入规格编码': '请输入规格编码',
  '规格编码不能少于2位': '规格编码不能少于2位',
  '规格编码只能包含数字、英文大小写': '规格编码只能包含数字、英文大小写',
  '请输入产品名称': '请输入产品名称',
  '图片尺寸为800x800': '图片尺寸为800x800',
  '规格编码': '规格编码',
  '请输入规格编码': '请输入规格编码',
  '规格编码为数字+英文大小写的6位编码': '规格编码为数字+英文大小写的6位编码',
  '图片格式为.jpeg、.jpg、.png': '图片格式为.jpeg、.jpg、.png',
  '图片必须小于1M': '图片必须小于1M',
  '图片尺寸必须为800x800': '图片尺寸必须为800x800',
  '产品指导价': '产品指导价',
  '国家': '国家',
  '价格': '价格',
  '请添加指导价': '请添加指导价',
  '请选择国家': '请选择国家',
  '国家重复': '国家重复',
  '功能列表': '功能列表',
  '设备锁': '设备锁',
}

const AgentPage = {
  '代理账号': '代理账号',
  '代理名称': '代理名称',
  '代理总数': '代理总数',
  '代理手机号': '代理手机号',
  '代理邮箱': '代理邮箱',
  '地区': '地区',
  '地址': '地址',
  '请输入代理账号': '请输入代理账号',
  '代理账号只能包含数字和英文字母': '代理账号只能包含数字和英文字母',
  '请输入代理名称': '请输入代理名称',
  '代理名称长度必须介于 2 和 20 之间': '代理名称长度必须介于 2 和 20 之间',
  '请输入代理手机号': '请输入代理手机号',
  '手机号只包含数字': '手机号只包含数字',
  '手机号无需加区号': '手机号无需加区号',
  '请输入代理邮箱': '请输入代理邮箱',
  '请选择地区': '请选择地区',
  '请输入地址': '请输入地址',
  '下级代理': '下级代理',
  '代理采购记录': '代理采购记录',
  '代理库存': '代理库存',
  '拥有者': '拥有者',
  '迁移': '迁移',
  '迁移代理': '迁移代理',
  '请选择拥有者': '请选择拥有者',
  '采购时间': '采购时间',
  '下载模版': '下载模版',
  '下载成功': '下载成功',
  '下载失败': '下载失败',
  '代理导入模版': '代理导入模版',
  '导入成功': '导入成功',
  '导入失败': '导入失败',
}

const SupplierPage = {
  '供应商账号': '供应商账号',
  '供应商名称': '供应商名称',
  '请输入供应商名称': '请输入供应商名称',
  '供应商联系方式': '供应商联系方式',
  '请输入供应商联系方式': '请输入供应商联系方式',
  '供应商地址': '供应商地址',
  '请输入供应商地址': '请输入供应商地址',
  '查看供应商': '查看供应商',
}

const StatisticsPage = {
  '用户': '用户',
  '绑定信息': '绑定信息',
  '库存数量': '库存数量',
  '代理入库总数': '代理入库总数',
  '产品未激活总数': '产品未激活总数',
  '产品激活详情': '产品激活详情',
  '产品激活排行': '产品激活排行',
  '售后产品数': '售后产品数',
  '请输入名称搜索内容': '请输入名称搜索内容',
  '总代账号': '总代账号',
  '全店数据概况': '全店数据概况',
  '统计首页': '统计首页',
  '首页': '首页',
  '至': '至',
  '表格': '表格',
  '图标': '图标',
  '注册人数': '注册人数',
  '总代理商名称': '总代理商名称',
  '总代理名称': '总代理名称',
  '总代理商号': '总代理商号',
  '总代理昵称': '总代理昵称',
  '代理门店数': '代理门店数',
  '员工数': '员工数',
  '采购数': '采购数',
  '业务员': '业务员',
  '结束时间': '结束时间',
  '平台数据概况': '平台数据概况',
  '统计时间': '统计时间',
  '代理数据概况': '代理数据概况',
  '激活数量': '激活数量',
  '用户绑定': '用户绑定',
  '产品售后': '产品售后',
  '代理门店': '代理门店',
  '地区总代总数': '地区总代总数',
  '销售单总数': '销售单总数',
  '采购单总数': '采购单总数',
  '统计': '统计',
  '用户绑定总数': '用户绑定总数',
  '代理门店总数': '代理门店总数',
  '代理门店数': '代理门店数',
  '操作': '操作',
  '详情': '详情',
  '请输入代理名称': '请输入代理名称',
  '代理名称': '代理名称',
  '代理总数': '代理总数',
  '账号': '账号',
  '代理地区': '代理地区',
  '发展员名称': '发展员名称',
  '发展员账号': '发展员账号',
  '请输入搜索内容': '请输入搜索内容',
  '产品售后总数': '产品售后总数',
  '商品排名分析': '商品排名分析',
  '数据详情': '数据详情',
  '产品激活排名详情': '产品激活排名详情',
  '排名': '排名',
  '用户绑定数': '用户绑定数',
  "采购订单数": "采购订单数",
  '更新于': '更新于',
  '今日': '今日',
  '日': '日',
  '周': '周',
  '月': '月',
  '开始日期': '开始日期',
  '结束日期': '结束日期',
  '数据首页': '数据首页',
  '用户总注册人数': '用户总注册人数',
  '产品销售总数': '产品销售总数',
  '产品激活总数': '产品激活总数',
  '代理总数': '代理总数',
  '用户注册人数': '用户注册人数',
  '产品销售数': '产品销售数',
  '产品激活数': '产品激活数',
  '入库数量': '入库数量',
  '未激活数量': '未激活数量',
  '产品编号': '产品编号',
  '代理地区': '代理地区',
  '请输入搜索内容': '请输入搜索内容',
  '销售单总数': '销售单总数',
  '订单编号': '订单编号',
  '销售数量': '销售数量',
  '销售时间': '销售时间',
  '售后数量': '售后数量',
  '销售单数': '销售单数',
  '产品售后数量': '产品售后数量',
  '请输入搜索名称': '请输入搜索名称',
  '销售订单数': '销售订单数',
  '销售员': '销售员',
  '销售员账号': '销售员账号',
  '产品编码': '产品编码',
  '绑定时间': '绑定时间',
  '激活信息': '激活信息',
  '用户绑定总数': '用户绑定总数',
  '总代理商名称': '总代理商名称',
  '总代理账号': '总代理账号',
  '用户绑定数': '用户绑定数',
  '注册时间': '注册时间',
  '请输入国家名称': '请输入国家名称',
  '详情功能暂未开放': '详情功能暂未开放',
  '剩余保修时间': '剩余保修时间',
  '天': '天',
  '销售单产品总数': '销售单产品总数',
  '出库数量': '出库数量',
  '代理入库数量': '代理入库数量',
  '未激活数量': '未激活数量',
  '产品售后数': '产品售后数',
  '销售单时间': '销售单时间',
  '订单编号': '订单编号',
  '起始时间': '起始时间',
  '结束时间': '结束时间',
  '无图片': '无图片',
  '代理数': '代理数',
  '请选择': '请选择',
  '产品销售': '产品销售',
  '产品激活': '产品激活',
  '销售方': '销售方',
  '激活方': '激活方',
  '归属方': '归属方',
  '激活账号': '激活账号',
  '激活门店': '激活门店',
  '剩余保修时间': '剩余保修时间',
  '产品激活时间': '产品激活时间',
  '用户绑定时间': '用户绑定时间',
  '绑定数量': '绑定数量',
  '国家地区': '国家地区',
  '注册时间': '注册时间',
  '各国注册人数对比': '各国注册人数对比',
  '暂无绑定信息': '暂无绑定信息',
  '账号名称': '账号名称',
  '采购产品数': '采购产品数',
  '产品入库数': '产品入库数',
  '产品出库数': '产品出库数',
  '库存总数': '库存总数',
  '采购工厂': '采购工厂',
  '采购工厂账号': '采购工厂账号',
  '采购单时间': '采购单时间',
  '订单总数': '订单总数',
  '产品采购总数': '产品采购总数',
  '产品入库总数': '产品入库总数',
  '产品出库总数': '产品出库总数',
  '激活总数': '激活总数',
  '未激活总数': '未激活总数',
  '售后总数': '售后总数',
  '请输入产品名称': '请输入产品名称',
  '代理门店': '代理门店',
  '代理账号': '代理账号',
  '手机号': '手机号',
  '邮箱': '邮箱',
  '业务员名称': '业务员名称',
  '业务员账号': '业务员账号',
  '售后数': '售后数',
  '售后信息': '售后信息',
  '售后门店': '售后门店',
  '售后账号': '售后账号',
  '原产品编码': '原产品编码',
  '更换产品编码': '更换产品编码',
  '绑定用户': '绑定用户',
  '用户账号': '用户账号',
  '产品激活时间': '产品激活时间',
  '用户绑定时间': '用户绑定时间',
  '售后时间': '售后时间',
  '代理名称': '代理名称',
  '用户名': '用户名',
  '昵称': '昵称',
  '保修天数': '保修天数',
  '激活时间': '激活时间',
  '绑定时间': '绑定时间',
  '创建时间': '创建时间',
  '激活数': '激活数',
  '用户绑定数': '用户绑定数',
  '激活门店': '激活门店',
  '激活账号': '激活账号',
  '激活昵称': '激活昵称',
  '绑定昵称': '绑定昵称',
  '绑定账号': '绑定账号',
  '销售详情': '销售详情',
  '请输入代理门店名称': '请输入代理门店名称',
  '销售方名称': '销售方名称',
  '销售方账号': '销售方账号',
}

const InsiteMessagePage = {
  '标题': '标题',
  '内容': '内容',
  '已读': '已读',
  '未读': '未读',
  '全部已读': '全部已读',
  '确定全部设置为已读': '确定全部设置为已读',
  '发送时间': '发送时间',
  '查看消息': '查看消息',
  '您有新的销售单': '您有新的销售单',
  '订单号：{no}\n采购方：{purchaseTenantName}\n产品名称：{productName}\n件数：{caseQuantity}\n个数：{quantity}\n请尽快接单！': '订单号：{no}\n采购方：{purchaseTenantName}\n产品名称：{productName}\n件数：{caseQuantity}\n个数：{quantity}\n请尽快接单！',
  '订单号：{no}\n采购方：{purchaseTenantName}\n产品名称：{productName}\n数量：{quantity}\n请尽快接单！': '订单号：{no}\n采购方：{purchaseTenantName}\n产品名称：{productName}\n数量：{quantity}\n请尽快接单！',
  '订单备注更新': '订单备注更新',
  '订单号：{no}\n备注：{remark}': '订单号：{no}\n备注：{remark}',
  '销售单作废': '销售单作废',
  '订单号：{no}\n采购方：{purchaseTenantName}\n作废时间：{time}': '订单号：{no}\n采购方：{purchaseTenantName}\n作废时间：{time}',
  '完成销售单': '完成销售单',
  '订单号：{no}\n采购方：{purchaseTenantName}\n完成时间：{time}': '订单号：{no}\n采购方：{purchaseTenantName}\n完成时间：{time}',
  '采购单接单': '采购单接单',
  '订单号：{no}\n销售方：{saleTenantName}\n接单时间：{time}': '订单号：{no}\n销售方：{saleTenantName}\n接单时间：{time}',
  '采购单作废': '采购单作废',
  '订单号：{no}\n销售方：{saleTenantName}\n作废时间：{time}': '订单号：{no}\n销售方：{saleTenantName}\n作废时间：{time}',
  '生产入库': '生产入库',
  '完成生产入库': '完成生产入库',
  '采购单发货': '采购单发货',
  '订单号：{no}\n销售方：{saleTenantName}\n件数：{caseQuantity}\n个数：{quantity}\n发货时间：{time}': '订单号：{no}\n销售方：{saleTenantName}\n件数：{caseQuantity}\n个数：{quantity}\n发货时间：{time}',
  '订单号：{no}\n销售方：{saleTenantName}\n个数：{quantity}\n发货时间：{time}': '订单号：{no}\n销售方：{saleTenantName}\n个数：{quantity}\n发货时间：{time}',
  '销售出库': '销售出库',
  '订单号：{no}\n件数：{caseQuantity}\n个数：{quantity}\n出库时间：{time}': '订单号：{no}\n件数：{caseQuantity}\n个数：{quantity}\n出库时间：{time}',
  '订单号：{no}\n个数：{quantity}\n出库时间：{time}': '订单号：{no}\n个数：{quantity}\n出库时间：{time}',
  '采购入库': '采购入库',
  '订单号：{no}\n件数：{caseQuantity}\n个数：{quantity}\n入库时间：{time}': '订单号：{no}\n件数：{caseQuantity}\n个数：{quantity}\n入库时间：{time}',
  '订单号：{no}\n个数：{quantity}\n入库时间：{time}': '订单号：{no}\n个数：{quantity}\n入库时间：{time}',
  '完成采购单': '完成采购单',
  '产品激活': '产品激活',
  '产品名称：{productName}\n激活人员：{staffName}\n激活时间：{time}': '产品名称：{productName}\n激活人员：{staffName}\n激活时间：{time}',
  '库存预警': '库存预警',
  '产品名称：{productName}\n数量：{quantity}\n请尽快补货！': '产品名称：{productName}\n数量：{quantity}\n请尽快补货！',
  '产品售后': '产品售后',
  '产品名称：{productName}\n旧编码：{oldProductCode}\n新编码：{newProductCode}\n售后时间：{time}\n售后人员：{staffName}': '产品名称：{productName}\n旧编码：{oldProductCode}\n新编码：{newProductCode}\n售后时间：{time}\n售后人员：{staffName}',
  '新的退货申请': '新的退货申请',
  '产品名称：{productName}\n申请方：{applicantName}\n个数：{quantity}\n申请方：{applierName}': '产品名称：{productName}\n申请方：{applicantName}\n个数：{quantity}\n申请方：{applierName}',
  '退货收货': '退货收货',
  '产品名称：{productName}\n审批方：{approverName}\n个数：{quantity}\n收货时间：{time}': '产品名称：{productName}\n审批方：{approverName}\n个数：{quantity}\n收货时间：{time}',
  '退货发货': '退货发货',
  '产品名称：{productName}\n审批方：{approverName}\n个数：{quantity}\n发货时间：{time}': '产品名称：{productName}\n审批方：{approverName}\n个数：{quantity}\n发货时间：{time}',
  '完成退货': '完成退货',
  '产品名称：{productName}\n申请方：{applicantName}\n个数：{quantity}\n完成时间：{time}': '产品名称：{productName}\n申请方：{applicantName}\n个数：{quantity}\n完成时间：{time}',
}

const AgentPurchasePage = {
  '采购方': '采购方',
  '代购人': '代购人',
  '代理': '代理',
  '请选择代理': '请选择代理',
}

const CampaignPage = {
  '活动名称': '活动名称',
  '开奖状态': '开奖状态',
  '开奖进度': '开奖进度',
  '开奖编码': '开奖编码',
  '领取状态': '领取状态',
  '已领取': '已领取',
  '未领取': '未领取',
  '未发布': '未发布',
  '参与中': '参与中',
  '待开奖': '待开奖',
  '开奖中': '开奖中',
  '已结束': '已结束',
  '活动名称': '活动名称',
  '查看地区': '查看地区',
  '信息收集': '信息收集',
  '活动条件': '活动条件',
  '活动产品': '活动产品',
  '选择产品': '选择产品',
  '开奖人数': '开奖人数',
  '参与范围': '参与范围',
  '产品来源仅限': '产品来源仅限',
  '起始时间': '起始时间',
  '产品购买时间在': '产品购买时间在',
  '后': '后',
  '奖品': '奖品',
  '奖品名称': '奖品名称',
  '奖品图片': '奖品图片',
  '图片尺寸为1:1': '图片尺寸为1:1',
  '奖品价值': '奖品价值',
  '奖品数量': '奖品数量',
  '中奖规则': '中奖规则',
  '规则描述': '规则描述',
  '活动图': '活动图',
  '图片尺寸为690x420': '图片尺寸为690x420',
  '内容': '内容',
  '图片宽度为750像素': '图片宽度为750像素',
  '图片必须小于5M': '图片必须小于5M',
  '其他信息': '其他信息',
  '领奖最后期限': '领奖期限',
  '手机号码': '手机号码',
  '开奖后': '开奖后',
  '天': '天',
  '请输入活动名称': '请输入活动名称',
  '请上传图片': '请上传图片',
  '请完善活动详情': '请完善活动详情',
  '请选择活动产品': '请选择活动产品',
  '请输入开奖人数': '请输入开奖人数',
  '请选择查看地区': '请选择查看地区',
  '请选择代理': '请选择代理',
  '请选择起始时间': '请选择起始时间',
  '请输入奖品名称': '请输入奖品名称',
  '请上传奖品图片': '请上传奖品图片',
  '请输入奖品数量': '请输入奖品数量',
  '请选择信息收集方式': '请选择信息收集方式',
  '请输入规则描述': '请输入规则描述',
  '请输入领奖最后期限': '请输入领奖最后期限',
  '发布': '发布',
  '确定发布': '确定发布',
  '撤销': '撤销',
  '确定撤销': '确定撤销',
  '中奖信息': '中奖信息',
  '中奖编码': '中奖编码',
  '中奖用户': '中奖用户',
  '用户信息': '用户信息',
  '领奖状态': '领奖状态',
  '选择': '选择',
  '最多10个产品': '最多10个产品',
  '时间类型': '时间类型',
  '起止时间': '起止时间',
  '请选择终止时间': '请选择终止时间',
  '起始时间不能大于终止时间': '起始时间不能大于终止时间',
};

const BackEnd = {
  'No_Third_Party_Active_Code': '第三方激活码不存在',
  'Error_Third_Party_Active_Code': '错误第三方激活码',
  'Not_Print_Third_Party_Active_Code': '未打印第三方激活码',
  'No_After_Sale_Code': '售后码不存在',
  'No_Goods': '产品不存在',
  'Not_Sale_Goods': '非销售产品',
  'No_Product_Code': '产品码不存在',
  'After_Sale_Code_Not_Belong_Product_Code': '售后码不属于该产品码',
  'No_New_Product_Code': '新产品码不存在',
  'Error_Product_Code': '异常产品码',
  'Not_Print_Product_Code': '未打印产品码',
  'Not_Same_Product': '非同一产品',
  'Active': '已激活',
  'Out_Of_Stock': '库存不足',
  'No_App_User': '用户不存在',
  'Invalid_Active_Code_Or_Invalid_Product_Code': '非法激活码/产品码',
  'No_Active_Code': '激活码不存在',
  'Not_Active': '未激活',
  'Bind': '已绑定',
  'Account_Exist': '账号重复',
  'Concat_Superior_Reset_Password': '联系上级重置密码',
  'No_User': '用户不存在',
  'Old_Password_Error': '旧密码错误',
  'No_Active_Code_Order': '第三方激活码订单不存在',
  'Invalid_Active_Code_Order_Status': '非法第三方激活码订单状态',
  'Invalid_Quantity': '数量错误',
  'No_Agent': '代理不存在',
  'Select_Agent': '请选择代理',
  'No_Staff': '员工不存在',
  'Enter_Agent_Name': '请输入代理名称',
  'Enter_Agent_Phone': '请输入代理手机号码',
  'Select_Agent_Region': '请选择代理地区',
  'Enter_Agent_Address': '请输入代理地址',
  'Select_Product': '请选择产品',
  'Enter_Goods_Quantity': '请输入产品数量',
  'Upload_File': '请上传文件',
  'No_Insite_Message': '消息不存在',
  'No_Product': '产品不存在',
  'Enter_Price': '请输入单价',
  'Invalid_Price': '非法单价',
  'Select_Produce_Order': '请选择生产单',
  'Select_Print_Type': '请选择打印类型',
  'Invalid_Print_Type': '非法打印类型',
  'No_Produce_Order': '生产单不存在',
  'Invalid_Produce_Order_Status': '非法生产单状态',
  'Out_Of_Produce_Order_Goods_Quantity': '超过生产数量',
  'Invalid_Box_Code': '非法装箱码',
  'No_Box_Code': '装箱码不存在',
  'Error_Box_Code': '异常装箱码',
  'Not_Print_Box_Code': '未打印装箱码',
  'Not_Same_Produce_Order': '非同一生产单',
  'Produce_In_Warehouse': '已生产入库',
  'Select_Goods': '请选择产品',
  'Some_Goods_In_Warehouse': '部分产品已入库，不能作废',
  'Error_Active_Code': '异常激活码',
  'Not_Print_Active_Code': '未打印激活码',
  'Product_Associate_Box': '产品已关联包装盒',
  'Box_Not_Associate_Product': '包装盒未关联产品',
  'Box_Associate_Case': '包装盒已关联包装箱',
  'Enter_Box_Quantity': '请输入箱规',
  'Scan_Active_Code': '请扫描激活码',
  'Invalid_Active_Code': '非法激活码',
  'Scan_Product_Code': '请扫描产品码',
  'Invalid_Product_Code': '非法产品码',
  'Scan_Box_Code': '请扫描装箱码',
  'Success': '成功',
  'Product_Name_Exist': '产品名称重复',
  'Sku_Exist': '规格编码重复',
  'Enter_Product_Name': '请输入产品名称',
  'Enter_Product_Sku': '请输入规格编码',
  'Not_Allow_Modify_Super_User': '不允许修改超管账号',
  'No_Permission': '无权限',
  'Import_Empty_User_Data': '导入用户数据为空',
  'No_Purchase_Order': '采购单不存在',
  'Invalid_Purchase_Order_Status': '非法采购单状态',
  'Out_Of_Purchase_Order_Goods_Quantity': '超过采购数量',
  'Not_Belong_Purchase_Order': '不属于该采购单',
  'Select_Purchase_Order': '请选择采购单',
  'Select_PurchaseTenant': '请选择采购商',
  'Has_Goods_Not_Purchase_In_Warehouse': '销售方已发货，但未入库',
  'No_Sale_Order': '销售单不存在',
  'Select_ShipmentTime': '请选择发货时间',
  'No_Return_Goods': '退货不存在',
  'No_After_Sale': '售后不存在',
  'Return_Goods': '已退货',
  'Invalid_Return_Goods_Record_Status': '非法退货记录状态',
  'Not_Belong_Return_Goods_Record': '不属于该退货申请',
  'Received': '已收货',
  'Out_Of_Return_Goods_Quantity': '超过退货数量',
  'No_Return_Goods_Record': '退货记录不存在',
  'Invalid_Approver': '非法审核员',
  'Not_In_Warehouse': '不在库存',
  'Reship': '已补发',
  'Select_Return_Goods_Record': '请选择退货记录',
  'No_Allow_Operate_Super_Role': '不允许操作超级管理员角色',
  'No_Permission_Access_Role': '没有权限访问角色',
  'No_Permission_Access_Dept': '没有权限访问部门',
  'No_Allow_Add_Dept': '部门停用，不允许新增',
  'Invalid_Sale_Order_Status': '非法销售单状态',
  'Some_Goods_Out_Warehouse': '部分产品已出库，不能作废',
  'Out_Of_Sale_Order_Goods_Quantity': '超过销售数量',
  'Select_Sale_Order': '请选择销售单',
  'Not_Associate': '未关联',
  'Scan_Code': '请扫码',
  'Enter_Nick_Name': '请输入名称',
  'Select_MenuIds': '请选择菜单',
  'No_Stock_Change': '库存变动不存在',
  'Enter_Supplier_Name': '请输入供应商名称',
  'Enter_Supplier_Phone': '请输入供应商手机号码',
  'Enter_Company_Name': '请输入公司名称',
  'Enter_Company_Phone': '请输入公司手机号码',
  'Enter_Company_Email': '请输入公司邮箱',
  'Enter_Contact_Name': '请输入联系人名称',
  'Enter_Contact_Phone': '请输入联系人手机号码',
  'Enter_Contact_Email': '请输入联系人邮箱',
  'Enter_Captcha': '请输入验证码',
  'Captcha_Expire': '验证码过期',
  'Error_Captcha': '验证码错误',
  'Enter_Account/Password': '请输入账号/密码',
  'Password_Not_Between_Range': '密码不在指定范围',
  'User_Name_Not_Between_Range': '用户名不在指定范围',
  'IP_Be_Banned': 'IP禁止访问',
  'Account_Be_Deleted': '账号已删除',
  'Account_Be_Freeze': '账号已冻结',
  'Enter_User/Password': '请输入帐号/密码',
  'Account_Between_2_And_20': '账号长度在2-20之间',
  'Password_Between_6_And_20': '密码长度在6-20之间',
  'Error Account/Password': '错误账号/密码',
  'Enter_Mobile_Phone': '请输入手机号码',
  'Enter_Email': '请输入邮箱',
  'Frequently_Get_Captcha_Try_5_Minutes': '频繁获取验证码，5分钟后再试',
  'No_User/Password_Error': '用户不存在/密码错误',
  'Purchase_In_Warehouse': '已采购入库',
  'Sale_Out_Warehouse': '已销售出库',
  'Free': '空闲',
  'CustomCode': '第三方激活码',
  'Order_Out_Of_Limit（999）': '超过上限（999）',
  'Other': '其他',
  'No_Campaign': '活动不存在',
  'Not_In_Participate': '不在参与期',
  'Has_Participant': '存在参与的用户',
  'Has_One_Active': '存在发布的活动',
  'Has_One_Participate': '存在已有参与用户的活动',
  'Participated': '已参与',
  'No_Valid_Bind_Product': '未绑定符合条件的产品',
  'Invalid_Accept_No': '非法领奖码',
  'Accept_Prize': '已领奖',
  'Scan_Accept_No': '请扫描领奖码',
  'Out_Of_Accept_Deadline': '超过领奖最后期限',
  'Enter_Title': '请输入活动名称',
  'Upload_Banner': '请上传Banner',
  'Enter_Content': '请完善内容',
  'Enter_Max_Participant_Quantity': '请输入参与人数上限',
  'Select_Limit_Date': '请选择限制时间',
  'Improve_Prize': '请完善奖品',
  'Select_Contact_Method': '请选择联系方式',
  'Enter_Rule_Desc': '请输入规则描述',
  'Enter_Accept_Deadline': '请输入领奖期限',
  'Enter_Phone': '请输入手机号码',
  'Out_Of_Max_Participant_Quantity': '超过参与人数上限',
  'Not_Bind': '未绑定',
  'Select_Purchase_Order': '请选择采购单',
  'Empty_Product_Code': '产品编码不能为空',
  'Product_Not_Found': '产品不存在',
  'Empty_Box_Code': '箱码为空',
  'Print_Failed': '打印失败，请检查打印机状态',
  'Product_Code_Not_Exist': '产品码不存在',
  'Box_Code_Not_Exist': '箱码不存在',
  'System_Clock_Backwards': '系统时钟回拨，拒绝生成ID',
  'Empty_User_Id': '用户ID不能为空',
  'Empty_Tenant_Id': 'tenantId不能为空',
  'Empty_Product_Id': 'productId不能为空',
  'Please_Enter_Product_Id': '请填入productId',
  'Invalid_Product_Code_Empty_Part': '产品代码空部分无效',
  'Invalid_Product_Code_Format': '产品代码格式无效',
  'Not_Same_Product': '非同款产品',
  'Empty_Code': '验证码为空',
  'Product_Not_Exist': '产品不存在',
  'Product_Unlocked': '产品已解锁',
  'Product_Not_Activated': '产品未激活',
  'Inconsistent_Product_Code': '产品码不一致',
  'No_Empty_Type': '类型不能为空',
  'No_Empty_Reason': '原因不能为空',
  'Invalid_Product_Code_Or_Invalid_Active_Code': '无效产品码或激活码',
  '请选择要导入的文件': '请选择要导入的文件',
  '请使用正确的导入模板': '请使用正确的导入模板',
  '文件名不能为空': '文件名不能为空',
  '文件格式错误': '文件格式错误',
  '请上传Excel文件': '请上传Excel文件',
  'Excel格式错误': 'Excel格式错误',
  'Excel内容为空': 'Excel内容为空',
  'Row{}：Enter_Agent_Account': '第{}行：请输入代理账号',
  'Row{}：UserName_Only_Contain_Number_And_English': '第{}行：账号只包含数字和英文',
  'Row{}：UserName_Exist': '第{}行：账号已存在',
  'Row{}：Enter_Agent_Name': '第{}行：请输入代理名称',
  'Row{}：Enter_Phone_Number': '第{}行：请输入手机号码',
  'Row{}：Invalid_Phone_Number': '第{}行：无效手机号码',
  'Row{}：Select_Region': '第{}行：请选择地区',
  'Row{}：Invalid_Region': '第{}行：无效地区',
  'Row{}：Enter_Address': '第{}行：请输入地址',
  '生成Excel失败': '生成Excel失败',
  '请输入国家名称': '请输入国家名称',
  '订单不存在': '订单不存在',
  '箱规必须大于0': '箱规必须大于0',
  '箱子已绑定产品，不能删除': '箱子已绑定产品，不能删除',
  '箱子不存在': '箱子不存在',
  '该箱已绑定产品': '该箱已绑定产品',
  '订单ID不能为空': '订单ID不能为空',
  'Enter_Agent_Account': '请输入代理账号',
  'Enter_Staff_Account': '请输入员工账号',
  'UserName_Only_Contain_Number_And_English': '账号只包含数字和英文',
  'UserName_Exist': '账号已存在',
  'Enter_Staff_Name': '请输入员工名称',
  'Enter_Remark': '请输入备注',
}

export default {
  ...Common,
  ...Menu,
  ...Region,
  ...Layout,
  ...ModifyPasswordPage,
  ...LoginPage,
  ...TenantPage,
  ...RolePage,
  ...StaffPage,
  ...PrintRecordPage,
  ...ThirdPartyActivationCodeOrderPage,
  ...ThirdPartyActivationCodeRecordPage,
  ...TraceCodePage,
  ...ReturnPage,
  ...StockChangePage,
  ...StockPage,
  ...SaleOutWarehousePage,
  ...SaleOrderPage,
  ...PurchaseInWarehousePage,
  ...PurchaseOrderPage,
  ...AppUserPage,
  ...ProduceInWarehousePage,
  ...ProduceOrderPage,
  ...OnSaleProductPage,
  ...ProductPage,
  ...AgentPage,
  ...SupplierPage,
  ...StatisticsPage,
  ...InsiteMessagePage,
  ...AgentPurchasePage,
  ...CampaignPage,
  ...BackEnd,
}